export default __webpack_public_path__ + "static/media/help_main-photo_ng1.65a2027b.jpg";